import { Box, IconButton, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getFromStorage } from '../utils/storage'
import DeleteIcon from '@mui/icons-material/Delete'
import { updateFormActions } from '../redux/store'
import { socket } from '../utils/socket'
import ThumbUpIcon from '@mui/icons-material/ThumbUp'
import ContentCutIcon from '@mui/icons-material/ContentCut'
import LocalOfferIcon from '@mui/icons-material/LocalOffer'
import TagModal from './TagModal'
import { orderPanelStyles } from './common/orderPanelStyles'
import Loading from './Loading'
import ExtendedIconButton from './button-icons/ExtendedIconButton'
import { enqueueSnackbar } from 'notistack'
import PanelOrderItem from './PanelOrderItem'
import { OrderStatus } from '../models'
import { mainBlue } from '../utils/color'

export default function ShippingPanel({ shipOrdersProps }) {
	//------INIT STATE------
	const { isLoading } = useSelector((state) => state.isLoading)
	const dispatch = useDispatch()
	const { currentUser } = useSelector((state) => state.currentUser)
	const token = getFromStorage('current-user')?.accessToken
	const [shipOrders, setShipOrders] = useState(shipOrdersProps)
	const [currentShippingServiceItem, setCurrentShippingServiceItem] = useState()
	const [expandedOrders, setExpandedOrders] = useState({})

	const handleTagClick = (item) => {
		setCurrentShippingServiceItem(item)
	}

	//------SCROLL TO BOTTOM------
	const messagesEndRef = useRef(null)

	const scrollToBottom = () => {
		messagesEndRef.current?.scrollIntoView({ behavior: 'instant' })
	}

	useEffect(() => {
		scrollToBottom()
	}, [shipOrders])

	useEffect(() => {
		setShipOrders(shipOrdersProps)
	}, [shipOrdersProps])

	//------POST END SHIP ORDERS------
	const endShipOrder = async function (data) {
		socket.emit('post-end-ship-order', data)
	}

	//------POST END OTHER SHIP ORDERS------
	const endOtherShipOrder = async function (data) {
		socket.emit('post-end-other-ship-order', data)
	}

	//-----DELETE ORDER-----
	const waitConfirmDeleteOrder = async function (data) {
		socket.emit('wait-confirm-delete-order', data)
	}

	if (isLoading) return <Loading />

	return (
		<Box sx={orderPanelStyles.container}>
			<Box sx={orderPanelStyles.ordersBox}>
				{shipOrders?.map((item, index) => (
					<PanelOrderItem
						key={item._id}
						order={item}
						index={index}
						expandedOrders={expandedOrders}
						renderActions={() => (
							<Box sx={orderPanelStyles.actionIcons}>
								{item.status !== OrderStatus.PENDING_DELETE_SHIP && item.status !== OrderStatus.CONFIRM_DELETE_SHIP && (
									<>
										{item?.shipper?.user?._id === currentUser.id &&
											item?.producer?.produceEnd != null &&
											!(item?.quickPurchase ?? false) &&
											currentUser.permission?.includes('completeDelivery') && (
												<IconButton
													onClick={() => {
														endShipOrder({
															orderId: item._id,
															store: currentUser.store,
															accessToken: token,
														})
													}}
													size='small'>
													<ThumbUpIcon fontSize='small' sx={{ color: mainBlue }} />
												</IconButton>
											)}

										{item?.shipper?.user?._id !== currentUser.id &&
											item?.shipper?.shipStart != null &&
											!(item?.quickPurchase ?? false) &&
											currentUser.permission?.includes('completeOtherDelivery') && (
												<IconButton
													onClick={() => {
														endOtherShipOrder({
															orderId: item._id,
															store: currentUser.store,
															accessToken: token,
															userConfirm: currentUser.id,
														})
													}}
													size='small'
													sx={orderPanelStyles.actionButton}>
													<ThumbUpIcon fontSize='small' sx={{ color: mainBlue }} />
												</IconButton>
											)}

										{currentUser.permission?.includes('updateOrder') && (
											<IconButton
												size='small'
												sx={orderPanelStyles.actionButton}
												onClick={(e) => {
													e.stopPropagation()
													dispatch(updateFormActions.editOrder(item))
													dispatch(updateFormActions.showUpdateForm())
												}}>
												<ContentCutIcon fontSize='small' sx={{ color: '#9C27B0', cursor: 'pointer' }} />
											</IconButton>
										)}

										{currentUser.permission?.includes('updateTag') && (
											<IconButton size='small' sx={{ color: '#ff0000' }} onClick={() => handleTagClick(item)}>
												<LocalOfferIcon
													sx={{ color: '#4CAF50', transform: 'rotate(90deg)', cursor: 'pointer' }}
													fontSize='small'
												/>
											</IconButton>
										)}

										{currentUser.permission?.includes('deleteOrder') && (
											<IconButton
												size='small'
												onClick={(e) => {
													e.stopPropagation()
													const deleteReason = window.prompt('Nhập lý do hủy')
													if (!deleteReason || deleteReason.trim() === '') {
														alert('Lý do hủy không được để trống!')
													} else {
														waitConfirmDeleteOrder({
															deletor: currentUser.id,
															storeId: currentUser.store,
															orderId: item._id,
															accessToken: token,
															deleteReason,
														})
														enqueueSnackbar('Chờ xác nhận xóa đơn hàng!')
													}
												}}
												sx={orderPanelStyles.deleteButton}>
												<DeleteIcon sx={{ color: '#f44336', cursor: 'pointer' }} fontSize='small' />
											</IconButton>
										)}
									</>
								)}

								{(item?.source || item?.code) && (
									<ExtendedIconButton
										isExpanded={expandedOrders[item._id]}
										onClick={() => setExpandedOrders((prev) => ({ ...prev, [item._id]: !prev[item._id] }))}
									/>
								)}
							</Box>
						)}
					/>
				))}
			</Box>

			{shipOrders?.length === 0 && (
				<Typography variant='h6' sx={orderPanelStyles.emptyMessage}>
					Chưa có đơn hàng đang giao
				</Typography>
			)}

			<Box ref={messagesEndRef} />
			{!!currentShippingServiceItem ? (
				<TagModal
					open={!!currentShippingServiceItem}
					onClose={() => setCurrentShippingServiceItem(null)}
					currentItem={currentShippingServiceItem}
				/>
			) : null}
		</Box>
	)
}
